document.addEventListener('DOMContentLoaded', function() {
     // Configuration de l'Intersection Observer
     const observerOptions = {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
     };

     // Créer l'observer pour détecter quand les blocs deviennent visibles
     const observer = new IntersectionObserver(function(entries) {
          entries.forEach(entry => {
               if (entry.isIntersecting) {
                    // Ajouter la classe is-visible pour déclencher l'animation
                    entry.target.classList.add('is-visible');
               }
          });
     }, observerOptions);

     // Observer tous les blocs à partir du 3ème (n+3)
     const stepsItems = document.querySelectorAll('.mm-steps-item:nth-child(n+3)');
     stepsItems.forEach(item => {
          observer.observe(item);
     });
});
